import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { REGIME_TRIBUTACAO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    REGIME_TRIBUTACAO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    REGIME_TRIBUTACAO_ENDPOINT,
    id
  ]);
}
